export default "__VITE_ASSET__czKDRDv9__"